(function () {
var $ce40f2a273fa4bda$var$debug_info = function(fe) {
    "use strict";
    function bn(r, u) {
        for(var l = 0; l < u.length; l++){
            const d = u[l];
            if (typeof d != "string" && !Array.isArray(d)) {
                for(const f in d)if (f !== "default" && !(f in r)) {
                    const p = Object.getOwnPropertyDescriptor(d, f);
                    p && Object.defineProperty(r, f, p.get ? p : {
                        enumerable: !0,
                        get: ()=>d[f]
                    });
                }
            }
        }
        return Object.freeze(Object.defineProperty(r, Symbol.toStringTag, {
            value: "Module"
        }));
    }
    function yn(r, u, l = 2e3) {
        let d = 0, f;
        function p() {
            d++, d === 1 ? f = setTimeout(()=>{
                d = 0;
            }, l) : d >= 3 && (clearTimeout(f), d = 0, u());
        }
        return r.addEventListener("click", p), ()=>{
            r.removeEventListener("click", p);
        };
    }
    function wn() {
        return {
            width: window.innerWidth,
            height: window.innerHeight
        };
    }
    function it(r) {
        return Object.entries(r).map(([u, l])=>`<p>${u}: ${l}</p>`).join(`
`);
    }
    function vn(r) {
        return Object.entries(r).map(([u, l])=>`${u}: ${l}`).join(`
`);
    }
    function Cn() {
        var _document_querySelector;
        var _document_querySelector_getAttribute;
        return (_document_querySelector_getAttribute = (_document_querySelector = document.querySelector("head base")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.getAttribute("href")) !== null && _document_querySelector_getAttribute !== void 0 ? _document_querySelector_getAttribute : "/";
    }
    async function kn(r, u = "GET", l) {
        let { body: d, headers: f, ...p } = l !== null && l !== void 0 ? l : {};
        d !== null && typeof d == "object" && (d = JSON.stringify(d), f = {
            "Content-Type": "application/json",
            ...f
        });
        const g = await fetch(new URL(r, new URL(Cn(), window.location.href)), {
            method: u,
            body: d,
            headers: f,
            ...p
        });
        if (!g.ok) throw new Error(`Request failed with status code ${g.status}`);
        return g;
    }
    function st(r, u, l) {
        const d = {};
        return l && (d["x-csrf-token"] = l), kn(r, "post", {
            body: u,
            headers: d
        });
    }
    let xe;
    function rt(r) {
        return {
            lang: xe === null || xe === void 0 ? void 0 : xe.lang,
            message: r === null || r === void 0 ? void 0 : r.message,
            abortEarly: xe === null || xe === void 0 ? void 0 : xe.abortEarly,
            abortPipeEarly: xe === null || xe === void 0 ? void 0 : xe.abortPipeEarly
        };
    }
    let En;
    function An(r) {
        return En === null || En === void 0 ? void 0 : En.get(r);
    }
    let Pn;
    function Bn(r) {
        return Pn === null || Pn === void 0 ? void 0 : Pn.get(r);
    }
    let Sn;
    function $n(r, u) {
        var _Sn_get;
        return Sn === null || Sn === void 0 ? void 0 : (_Sn_get = Sn.get(r)) === null || _Sn_get === void 0 ? void 0 : _Sn_get.get(u);
    }
    function lt(r) {
        var _Object_getPrototypeOf_constructor, _Object_getPrototypeOf;
        const u = typeof r;
        var _ref;
        return u === "string" ? `"${r}"` : u === "number" || u === "bigint" || u === "boolean" ? `${r}` : u === "object" || u === "function" ? (_ref = r && ((_Object_getPrototypeOf = Object.getPrototypeOf(r)) === null || _Object_getPrototypeOf === void 0 ? void 0 : (_Object_getPrototypeOf_constructor = _Object_getPrototypeOf.constructor) === null || _Object_getPrototypeOf_constructor === void 0 ? void 0 : _Object_getPrototypeOf_constructor.name)) !== null && _ref !== void 0 ? _ref : "null" : u;
    }
    function X(r, u, l, d, f) {
        var _f_expected, _ref, _f_received, _f_message, _ref1, _ref2, _ref3, _ref4;
        const p = f && "input" in f ? f.input : l.value, g = (_ref = (_f_expected = f === null || f === void 0 ? void 0 : f.expected) !== null && _f_expected !== void 0 ? _f_expected : r.expects) !== null && _ref !== void 0 ? _ref : null, L = (_f_received = f === null || f === void 0 ? void 0 : f.received) !== null && _f_received !== void 0 ? _f_received : lt(p), c = {
            kind: r.kind,
            type: r.type,
            input: p,
            expected: g,
            received: L,
            message: `Invalid ${u}: ${g ? `Expected ${g} but r` : "R"}eceived ${L}`,
            requirement: r.requirement,
            path: f === null || f === void 0 ? void 0 : f.path,
            issues: f === null || f === void 0 ? void 0 : f.issues,
            lang: d.lang,
            abortEarly: d.abortEarly,
            abortPipeEarly: d.abortPipeEarly
        }, x = r.kind === "schema", S = (_ref4 = (_ref3 = (_ref2 = (_ref1 = (_f_message = f === null || f === void 0 ? void 0 : f.message) !== null && _f_message !== void 0 ? _f_message : r.message) !== null && _ref1 !== void 0 ? _ref1 : $n(r.reference, c.lang)) !== null && _ref2 !== void 0 ? _ref2 : x ? Bn(c.lang) : null) !== null && _ref3 !== void 0 ? _ref3 : d.message) !== null && _ref4 !== void 0 ? _ref4 : An(c.lang);
        S !== void 0 && (c.message = typeof S == "function" ? S(c) : S), x && (l.typed = !1), l.issues ? l.issues.push(c) : l.issues = [
            c
        ];
    }
    function G(r) {
        return {
            version: 1,
            vendor: "valibot",
            validate (u) {
                return r["~run"]({
                    value: u
                }, rt());
            }
        };
    }
    function Tn(r, u) {
        const l = [
            ...new Set(r)
        ];
        var _l_;
        return l.length > 1 ? `(${l.join(` ${u} `)})` : (_l_ = l[0]) !== null && _l_ !== void 0 ? _l_ : "never";
    }
    var Ln = class extends Error {
        constructor(r){
            super(r[0].message), this.name = "ValiError", this.issues = r;
        }
    };
    function xn(r, u, l) {
        return typeof r.fallback == "function" ? r.fallback(u, l) : r.fallback;
    }
    function Ie(r, u, l) {
        return typeof r.default == "function" ? r.default(u, l) : r.default;
    }
    function Oe(r, u) {
        return {
            kind: "schema",
            type: "literal",
            reference: Oe,
            expects: lt(r),
            async: !1,
            literal: r,
            message: u,
            get "~standard" () {
                return G(this);
            },
            "~run" (l, d) {
                return l.value === this.literal ? l.typed = !0 : X(this, "type", l, d), l;
            }
        };
    }
    function ct(r, u) {
        return {
            kind: "schema",
            type: "nullish",
            reference: ct,
            expects: `(${r.expects} | null | undefined)`,
            async: !1,
            wrapped: r,
            default: u,
            get "~standard" () {
                return G(this);
            },
            "~run" (l, d) {
                return (l.value === null || l.value === void 0) && (this.default !== void 0 && (l.value = Ie(this, l, d)), l.value === null || l.value === void 0) ? (l.typed = !0, l) : this.wrapped["~run"](l, d);
            }
        };
    }
    function Me(r, u) {
        return {
            kind: "schema",
            type: "object",
            reference: Me,
            expects: "Object",
            async: !1,
            entries: r,
            message: u,
            get "~standard" () {
                return G(this);
            },
            "~run" (l, d) {
                const f = l.value;
                if (f && typeof f == "object") {
                    l.typed = !0, l.value = {};
                    for(const p in this.entries){
                        const g = this.entries[p];
                        if (p in f || (g.type === "exact_optional" || g.type === "optional" || g.type === "nullish") && g.default !== void 0) {
                            const L = p in f ? f[p] : Ie(g), c = g["~run"]({
                                value: L
                            }, d);
                            if (c.issues) {
                                var _l_issues;
                                const x = {
                                    type: "object",
                                    origin: "value",
                                    input: f,
                                    key: p,
                                    value: L
                                };
                                for (const S of c.issues)S.path ? S.path.unshift(x) : S.path = [
                                    x
                                ], (_l_issues = l.issues) === null || _l_issues === void 0 ? void 0 : _l_issues.push(S);
                                if (l.issues || (l.issues = c.issues), d.abortEarly) {
                                    l.typed = !1;
                                    break;
                                }
                            }
                            c.typed || (l.typed = !1), l.value[p] = c.value;
                        } else if (g.fallback !== void 0) l.value[p] = xn(g);
                        else if (g.type !== "exact_optional" && g.type !== "optional" && g.type !== "nullish" && (X(this, "key", l, d, {
                            input: void 0,
                            expected: `"${p}"`,
                            path: [
                                {
                                    type: "object",
                                    origin: "key",
                                    input: f,
                                    key: p,
                                    value: f[p]
                                }
                            ]
                        }), d.abortEarly)) break;
                    }
                } else X(this, "type", l, d);
                return l;
            }
        };
    }
    function ut(r, u) {
        return {
            kind: "schema",
            type: "optional",
            reference: ut,
            expects: `(${r.expects} | undefined)`,
            async: !1,
            wrapped: r,
            default: u,
            get "~standard" () {
                return G(this);
            },
            "~run" (l, d) {
                return l.value === void 0 && (this.default !== void 0 && (l.value = Ie(this, l, d)), l.value === void 0) ? (l.typed = !0, l) : this.wrapped["~run"](l, d);
            }
        };
    }
    function pe(r) {
        return {
            kind: "schema",
            type: "string",
            reference: pe,
            expects: "string",
            async: !1,
            message: r,
            get "~standard" () {
                return G(this);
            },
            "~run" (u, l) {
                return typeof u.value == "string" ? u.typed = !0 : X(this, "type", u, l), u;
            }
        };
    }
    function at(r, u, l) {
        return {
            kind: "schema",
            type: "variant",
            reference: at,
            expects: "Object",
            async: !1,
            key: r,
            options: u,
            message: l,
            get "~standard" () {
                return G(this);
            },
            "~run" (d, f) {
                const p = d.value;
                if (p && typeof p == "object") {
                    let g, L = 0, c = this.key, x = [];
                    const S = (he, je)=>{
                        for (const s of he.options){
                            if (s.type === "variant") S(s, new Set(je).add(s.key));
                            else {
                                let De = !0, F = 0;
                                for (const $ of je){
                                    const _ = s.entries[$];
                                    if ($ in p ? _["~run"]({
                                        typed: !1,
                                        value: p[$]
                                    }, {
                                        abortEarly: !0
                                    }).issues : _.type !== "exact_optional" && _.type !== "optional" && _.type !== "nullish") {
                                        De = !1, c !== $ && (L < F || L === F && $ in p && !(c in p)) && (L = F, c = $, x = []), c === $ && x.push(s.entries[$].expects);
                                        break;
                                    }
                                    F++;
                                }
                                if (De) {
                                    const $ = s["~run"]({
                                        value: p
                                    }, f);
                                    (!g || !g.typed && $.typed) && (g = $);
                                }
                            }
                            if (g && !g.issues) break;
                        }
                    };
                    if (S(this, new Set([
                        this.key
                    ])), g) return g;
                    X(this, "type", d, f, {
                        input: p[c],
                        expected: Tn(x, "|"),
                        path: [
                            {
                                type: "object",
                                origin: "value",
                                input: p,
                                key: c,
                                value: p[c]
                            }
                        ]
                    });
                } else X(this, "type", d, f);
                return d;
            }
        };
    }
    function In(r, u, l) {
        const d = r["~run"]({
            value: u
        }, rt(l));
        if (d.issues) throw new Ln(d.issues);
        return d.value;
    }
    const On = ct(at("type", [
        Me({
            type: Oe("mailtoBtn"),
            email: pe()
        }),
        Me({
            type: Oe("sendToBackend"),
            url: pe(),
            token: ut(pe())
        })
    ]));
    function Mn(r) {
        return In(On, r);
    }
    function jn(r) {
        return r ? r.type === "mailtoBtn" : !1;
    }
    function dt(r) {
        return r ? r.type === "sendToBackend" : !1;
    }
    function Dn(r, u, l) {
        const d = encodeURIComponent(u), f = encodeURIComponent(l);
        return `mailto:${r}?subject=${d}&body=${f}`;
    }
    function Hn(r) {
        const u = wn();
        return {
            url: window.location.href,
            version: r,
            viewportSize: `${u.width} x ${u.height}`,
            dpr: window.devicePixelRatio.toFixed(2),
            userAgent: navigator.userAgent
        };
    }
    function Fn(r, u) {
        var _r_querySelector;
        r === null || r === void 0 ? void 0 : (_r_querySelector = r.querySelector("button[data-action=copyToClipboard]")) === null || _r_querySelector === void 0 ? void 0 : _r_querySelector.addEventListener("click", async ()=>{
            const l = vn(u);
            try {
                await window.navigator.clipboard.writeText(l);
            } catch (d) {
                console.log("error copying to clipboard", d);
            }
        });
    }
    function Vn(r, u, l, d) {
        const f = r === null || r === void 0 ? void 0 : r.querySelector("button[data-action=sendInfo]");
        f === null || f === void 0 ? void 0 : f.addEventListener("click", async ()=>{
            if (f.disabled = !0, dt(u)) try {
                await st(u.url, l, u.token);
            } catch (p) {
                console.error("Error sending info", p);
            }
            d();
        }, {
            once: !0
        });
    }
    function qn(r, u, l) {
        const d = [];
        if (jn(r)) {
            const f = `<a href="${Dn(r.email, `${u}: Debug data`, it(l))}">
      <button class="button primary">
        Send as email
      </button>
    </a>`;
            d.push(f);
        }
        return dt(r) && d.push(`<button data-action="sendInfo" class="button primary">
      Send info
    </button>`), d;
    }
    async function _n(r, u, l) {
        const d = await Promise.resolve().then(()=>Un).then((g)=>g.default), f = Hn(u), p = qn(l, r, f).join(`
`);
        d.fire({
            html: it(f),
            footer: `
    ${p}
    <button data-action="copyToClipboard" class="button primary">Copy to clipboard</button>
    `,
            didOpen (g) {
                Fn(g, f), Vn(g, l, f, ()=>d.close());
            },
            customClass: {
                popup: "debug-popup"
            },
            showCloseButton: !0,
            showConfirmButton: !1,
            heightAuto: !1,
            allowOutsideClick: !1
        });
    }
    function ft(r, u, l, d) {
        r && yn(r, ()=>_n(u || "unknown", l || "unknown", d));
    }
    {
        const r = document.currentScript;
        window.addEventListener("DOMContentLoaded", ()=>{
            if (!r) {
                console.error("debug-info: Could not find script tag");
                return;
            }
            let u = r.getAttribute("data-trigger-selector");
            u || (console.error(`debug-info: Could not find trigger elenent. With selector: ${u}`), u = "#support");
            const l = document.querySelector(u);
            if (!l) {
                console.error("debug-info: Could not find trigger element");
                return;
            }
            let d = r.getAttribute("data-app-name");
            d || (console.warn("debug-info: Could not find app name"), d = "unknown");
            let f = r.getAttribute("data-version");
            f || (console.warn("debug-info: Could not find version"), f = "unknown");
            const p = r.getAttribute("data-email"), g = r.hasAttribute("data-send-to-backend"), L = g ? r.getAttribute("data-send-to-backend") : null, c = r.getAttribute("data-send-to-backend-url");
            if (g && !c) {
                console.error("debug-info: Could not find url");
                return;
            }
            const x = Mn({
                type: p ? "mailtoBtn" : "sendToBackend",
                email: p,
                token: L,
                url: c
            });
            ft(l, d, f, x);
        });
    }
    function Rn(r) {
        return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
    }
    var ge = {
        exports: {}
    };
    var q = ge.exports, pt;
    function Wn() {
        return pt || (pt = 1, function(r, u) {
            (function(l, d) {
                r.exports = d();
            })(q, function() {
                function l(e, t, n) {
                    if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
                    throw new TypeError("Private element is not present on this object");
                }
                function d(e, t) {
                    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                }
                function f(e, t) {
                    return e.get(l(e, t));
                }
                function p(e, t, n) {
                    d(e, t), t.set(e, n);
                }
                function g(e, t, n) {
                    return e.set(l(e, t), n), n;
                }
                const L = 100, c = {}, x = ()=>{
                    c.previousActiveElement instanceof HTMLElement ? (c.previousActiveElement.focus(), c.previousActiveElement = null) : document.body && document.body.focus();
                }, S = (e)=>new Promise((t)=>{
                        if (!e) return t();
                        const n = window.scrollX, o = window.scrollY;
                        c.restoreFocusTimeout = setTimeout(()=>{
                            x(), t();
                        }, L), window.scrollTo(n, o);
                    }), he = "swal2-", s = [
                    "container",
                    "shown",
                    "height-auto",
                    "iosfix",
                    "popup",
                    "modal",
                    "no-backdrop",
                    "no-transition",
                    "toast",
                    "toast-shown",
                    "show",
                    "hide",
                    "close",
                    "title",
                    "html-container",
                    "actions",
                    "confirm",
                    "deny",
                    "cancel",
                    "footer",
                    "icon",
                    "icon-content",
                    "image",
                    "input",
                    "file",
                    "range",
                    "select",
                    "radio",
                    "checkbox",
                    "label",
                    "textarea",
                    "inputerror",
                    "input-label",
                    "validation-message",
                    "progress-steps",
                    "active-progress-step",
                    "progress-step",
                    "progress-step-line",
                    "loader",
                    "loading",
                    "styled",
                    "top",
                    "top-start",
                    "top-end",
                    "top-left",
                    "top-right",
                    "center",
                    "center-start",
                    "center-end",
                    "center-left",
                    "center-right",
                    "bottom",
                    "bottom-start",
                    "bottom-end",
                    "bottom-left",
                    "bottom-right",
                    "grow-row",
                    "grow-column",
                    "grow-fullscreen",
                    "rtl",
                    "timer-progress-bar",
                    "timer-progress-bar-container",
                    "scrollbar-measure",
                    "icon-success",
                    "icon-warning",
                    "icon-info",
                    "icon-question",
                    "icon-error",
                    "draggable",
                    "dragging"
                ].reduce((e, t)=>(e[t] = he + t, e), {}), F = [
                    "success",
                    "warning",
                    "info",
                    "question",
                    "error"
                ].reduce((e, t)=>(e[t] = he + t, e), {}), $ = "SweetAlert2:", _ = (e)=>e.charAt(0).toUpperCase() + e.slice(1), P = (e)=>{
                    console.warn(`${$} ${typeof e == "object" ? e.join(" ") : e}`);
                }, U = (e)=>{
                    console.error(`${$} ${e}`);
                }, ht = [], Nn = (e)=>{
                    ht.includes(e) || (ht.push(e), P(e));
                }, mt = (e, t = null)=>{
                    Nn(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
                }, me = (e)=>typeof e == "function" ? e() : e, He = (e)=>e && typeof e.toPromise == "function", re = (e)=>He(e) ? e.toPromise() : Promise.resolve(e), Fe = (e)=>e && Promise.resolve(e) === e, B = ()=>document.body.querySelector(`.${s.container}`), le = (e)=>{
                    const t = B();
                    return t ? t.querySelector(e) : null;
                }, I = (e)=>le(`.${e}`), m = ()=>I(s.popup), Z = ()=>I(s.icon), zn = ()=>I(s["icon-content"]), bt = ()=>I(s.title), Ve = ()=>I(s["html-container"]), yt = ()=>I(s.image), qe = ()=>I(s["progress-steps"]), be = ()=>I(s["validation-message"]), D = ()=>le(`.${s.actions} .${s.confirm}`), J = ()=>le(`.${s.actions} .${s.cancel}`), N = ()=>le(`.${s.actions} .${s.deny}`), Kn = ()=>I(s["input-label"]), Q = ()=>le(`.${s.loader}`), ce = ()=>I(s.actions), wt = ()=>I(s.footer), ye = ()=>I(s["timer-progress-bar"]), _e = ()=>I(s.close), Yn = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, Re = ()=>{
                    const e = m();
                    if (!e) return [];
                    const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((a, h)=>{
                        const y = parseInt(a.getAttribute("tabindex") || "0"), v = parseInt(h.getAttribute("tabindex") || "0");
                        return y > v ? 1 : y < v ? -1 : 0;
                    }), o = e.querySelectorAll(Yn), i = Array.from(o).filter((a)=>a.getAttribute("tabindex") !== "-1");
                    return [
                        ...new Set(n.concat(i))
                    ].filter((a)=>T(a));
                }, We = ()=>V(document.body, s.shown) && !V(document.body, s["toast-shown"]) && !V(document.body, s["no-backdrop"]), we = ()=>{
                    const e = m();
                    return e ? V(e, s.toast) : !1;
                }, Xn = ()=>{
                    const e = m();
                    return e ? e.hasAttribute("data-loading") : !1;
                }, O = (e, t)=>{
                    if (e.textContent = "", t) {
                        const o = new DOMParser().parseFromString(t, "text/html"), i = o.querySelector("head");
                        i && Array.from(i.childNodes).forEach((h)=>{
                            e.appendChild(h);
                        });
                        const a = o.querySelector("body");
                        a && Array.from(a.childNodes).forEach((h)=>{
                            h instanceof HTMLVideoElement || h instanceof HTMLAudioElement ? e.appendChild(h.cloneNode(!0)) : e.appendChild(h);
                        });
                    }
                }, V = (e, t)=>{
                    if (!t) return !1;
                    const n = t.split(/\s+/);
                    for(let o = 0; o < n.length; o++)if (!e.classList.contains(n[o])) return !1;
                    return !0;
                }, Gn = (e, t)=>{
                    Array.from(e.classList).forEach((n)=>{
                        !Object.values(s).includes(n) && !Object.values(F).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
                    });
                }, M = (e, t, n)=>{
                    if (Gn(e, t), !t.customClass) return;
                    const o = t.customClass[n];
                    if (o) {
                        if (typeof o != "string" && !o.forEach) {
                            P(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`);
                            return;
                        }
                        b(e, o);
                    }
                }, ve = (e, t)=>{
                    if (!t) return null;
                    switch(t){
                        case "select":
                        case "textarea":
                        case "file":
                            return e.querySelector(`.${s.popup} > .${s[t]}`);
                        case "checkbox":
                            return e.querySelector(`.${s.popup} > .${s.checkbox} input`);
                        case "radio":
                            return e.querySelector(`.${s.popup} > .${s.radio} input:checked`) || e.querySelector(`.${s.popup} > .${s.radio} input:first-child`);
                        case "range":
                            return e.querySelector(`.${s.popup} > .${s.range} input`);
                        default:
                            return e.querySelector(`.${s.popup} > .${s.input}`);
                    }
                }, vt = (e)=>{
                    if (e.focus(), e.type !== "file") {
                        const t = e.value;
                        e.value = "", e.value = t;
                    }
                }, Ct = (e, t, n)=>{
                    !e || !t || (typeof t == "string" && (t = t.split(/\s+/).filter(Boolean)), t.forEach((o)=>{
                        Array.isArray(e) ? e.forEach((i)=>{
                            n ? i.classList.add(o) : i.classList.remove(o);
                        }) : n ? e.classList.add(o) : e.classList.remove(o);
                    }));
                }, b = (e, t)=>{
                    Ct(e, t, !0);
                }, j = (e, t)=>{
                    Ct(e, t, !1);
                }, R = (e, t)=>{
                    const n = Array.from(e.children);
                    for(let o = 0; o < n.length; o++){
                        const i = n[o];
                        if (i instanceof HTMLElement && V(i, t)) return i;
                    }
                }, z = (e, t, n)=>{
                    n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || parseInt(`${n}`) === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : n) : e.style.removeProperty(t);
                }, E = (e, t = "flex")=>{
                    e && (e.style.display = t);
                }, A = (e)=>{
                    e && (e.style.display = "none");
                }, Ue = (e, t = "block")=>{
                    e && new MutationObserver(()=>{
                        ue(e, e.innerHTML, t);
                    }).observe(e, {
                        childList: !0,
                        subtree: !0
                    });
                }, kt = (e, t, n, o)=>{
                    const i = e.querySelector(t);
                    i && i.style.setProperty(n, o);
                }, ue = (e, t, n = "flex")=>{
                    t ? E(e, n) : A(e);
                }, T = (e)=>!!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), Zn = ()=>!T(D()) && !T(N()) && !T(J()), Ne = (e)=>e.scrollHeight > e.clientHeight, Jn = (e, t)=>{
                    let n = e;
                    for(; n && n !== t;){
                        if (Ne(n)) return !0;
                        n = n.parentElement;
                    }
                    return !1;
                }, Et = (e)=>{
                    const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
                    return n > 0 || o > 0;
                }, ze = (e, t = !1)=>{
                    const n = ye();
                    n && T(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(()=>{
                        n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
                    }, 10));
                }, Qn = ()=>{
                    const e = ye();
                    if (!e) return;
                    const t = parseInt(window.getComputedStyle(e).width);
                    e.style.removeProperty("transition"), e.style.width = "100%";
                    const n = parseInt(window.getComputedStyle(e).width), o = t / n * 100;
                    e.style.width = `${o}%`;
                }, eo = ()=>typeof window > "u" || typeof document > "u", to = `
 <div aria-labelledby="${s.title}" aria-describedby="${s["html-container"]}" class="${s.popup}" tabindex="-1">
   <button type="button" class="${s.close}"></button>
   <ul class="${s["progress-steps"]}"></ul>
   <div class="${s.icon}"></div>
   <img class="${s.image}" />
   <h2 class="${s.title}" id="${s.title}"></h2>
   <div class="${s["html-container"]}" id="${s["html-container"]}"></div>
   <input class="${s.input}" id="${s.input}" />
   <input type="file" class="${s.file}" />
   <div class="${s.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${s.select}" id="${s.select}"></select>
   <div class="${s.radio}"></div>
   <label class="${s.checkbox}">
     <input type="checkbox" id="${s.checkbox}" />
     <span class="${s.label}"></span>
   </label>
   <textarea class="${s.textarea}" id="${s.textarea}"></textarea>
   <div class="${s["validation-message"]}" id="${s["validation-message"]}"></div>
   <div class="${s.actions}">
     <div class="${s.loader}"></div>
     <button type="button" class="${s.confirm}"></button>
     <button type="button" class="${s.deny}"></button>
     <button type="button" class="${s.cancel}"></button>
   </div>
   <div class="${s.footer}"></div>
   <div class="${s["timer-progress-bar-container"]}">
     <div class="${s["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), no = ()=>{
                    const e = B();
                    return e ? (e.remove(), j([
                        document.documentElement,
                        document.body
                    ], [
                        s["no-backdrop"],
                        s["toast-shown"],
                        s["has-column"]
                    ]), !0) : !1;
                }, K = ()=>{
                    c.currentInstance.resetValidationMessage();
                }, oo = ()=>{
                    const e = m(), t = R(e, s.input), n = R(e, s.file), o = e.querySelector(`.${s.range} input`), i = e.querySelector(`.${s.range} output`), a = R(e, s.select), h = e.querySelector(`.${s.checkbox} input`), y = R(e, s.textarea);
                    t.oninput = K, n.onchange = K, a.onchange = K, h.onchange = K, y.oninput = K, o.oninput = ()=>{
                        K(), i.value = o.value;
                    }, o.onchange = ()=>{
                        K(), i.value = o.value;
                    };
                }, io = (e)=>typeof e == "string" ? document.querySelector(e) : e, so = (e)=>{
                    const t = m();
                    t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true");
                }, ro = (e)=>{
                    window.getComputedStyle(e).direction === "rtl" && b(B(), s.rtl);
                }, lo = (e)=>{
                    const t = no();
                    if (eo()) {
                        U("SweetAlert2 requires document to initialize");
                        return;
                    }
                    const n = document.createElement("div");
                    n.className = s.container, t && b(n, s["no-transition"]), O(n, to), n.dataset.swal2Theme = e.theme;
                    const o = io(e.target);
                    o.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), so(e), ro(o), oo();
                }, Ke = (e, t)=>{
                    e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? co(e, t) : e && O(t, e);
                }, co = (e, t)=>{
                    e.jquery ? uo(t, e) : O(t, e.toString());
                }, uo = (e, t)=>{
                    if (e.textContent = "", 0 in t) for(let n = 0; (n in t); n++)e.appendChild(t[n].cloneNode(!0));
                    else e.appendChild(t.cloneNode(!0));
                }, ao = (e, t)=>{
                    const n = ce(), o = Q();
                    !n || !o || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? A(n) : E(n), M(n, t, "actions"), fo(n, o, t), O(o, t.loaderHtml || ""), M(o, t, "loader"));
                };
                function fo(e, t, n) {
                    const o = D(), i = N(), a = J();
                    !o || !i || !a || (Xe(o, "confirm", n), Xe(i, "deny", n), Xe(a, "cancel", n), po(o, i, a, n), n.reverseButtons && (n.toast ? (e.insertBefore(a, o), e.insertBefore(i, o)) : (e.insertBefore(a, t), e.insertBefore(i, t), e.insertBefore(o, t))));
                }
                function po(e, t, n, o) {
                    if (!o.buttonsStyling) {
                        j([
                            e,
                            t,
                            n
                        ], s.styled);
                        return;
                    }
                    b([
                        e,
                        t,
                        n
                    ], s.styled), o.confirmButtonColor && e.style.setProperty("--swal2-confirm-button-background-color", o.confirmButtonColor), o.denyButtonColor && t.style.setProperty("--swal2-deny-button-background-color", o.denyButtonColor), o.cancelButtonColor && n.style.setProperty("--swal2-cancel-button-background-color", o.cancelButtonColor), Ye(e), Ye(t), Ye(n);
                }
                function Ye(e) {
                    const t = window.getComputedStyle(e);
                    if (t.getPropertyValue("--swal2-action-button-focus-box-shadow")) return;
                    const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
                    e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
                }
                function Xe(e, t, n) {
                    const o = _(t);
                    ue(e, n[`show${o}Button`], "inline-block"), O(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = s[t], M(e, n, `${t}Button`);
                }
                const go = (e, t)=>{
                    const n = _e();
                    n && (O(n, t.closeButtonHtml || ""), M(n, t, "closeButton"), ue(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
                }, ho = (e, t)=>{
                    const n = B();
                    n && (mo(n, t.backdrop), bo(n, t.position), yo(n, t.grow), M(n, t, "container"));
                };
                function mo(e, t) {
                    typeof t == "string" ? e.style.background = t : t || b([
                        document.documentElement,
                        document.body
                    ], s["no-backdrop"]);
                }
                function bo(e, t) {
                    t && (t in s ? b(e, s[t]) : (P('The "position" parameter is not valid, defaulting to "center"'), b(e, s.center)));
                }
                function yo(e, t) {
                    t && b(e, s[`grow-${t}`]);
                }
                var w = {
                    innerParams: new WeakMap,
                    domCache: new WeakMap
                };
                const wo = [
                    "input",
                    "file",
                    "range",
                    "select",
                    "radio",
                    "checkbox",
                    "textarea"
                ], vo = (e, t)=>{
                    const n = m();
                    if (!n) return;
                    const o = w.innerParams.get(e), i = !o || t.input !== o.input;
                    wo.forEach((a)=>{
                        const h = R(n, s[a]);
                        h && (Eo(a, t.inputAttributes), h.className = s[a], i && A(h));
                    }), t.input && (i && Co(t), Ao(t));
                }, Co = (e)=>{
                    if (!e.input) return;
                    if (!C[e.input]) {
                        U(`Unexpected type of input! Expected ${Object.keys(C).join(" | ")}, got "${e.input}"`);
                        return;
                    }
                    const t = At(e.input);
                    if (!t) return;
                    const n = C[e.input](t, e);
                    E(t), e.inputAutoFocus && setTimeout(()=>{
                        vt(n);
                    });
                }, ko = (e)=>{
                    for(let t = 0; t < e.attributes.length; t++){
                        const n = e.attributes[t].name;
                        [
                            "id",
                            "type",
                            "value",
                            "style"
                        ].includes(n) || e.removeAttribute(n);
                    }
                }, Eo = (e, t)=>{
                    const n = m();
                    if (!n) return;
                    const o = ve(n, e);
                    if (o) {
                        ko(o);
                        for(const i in t)o.setAttribute(i, t[i]);
                    }
                }, Ao = (e)=>{
                    if (!e.input) return;
                    const t = At(e.input);
                    t && M(t, e, "input");
                }, Ge = (e, t)=>{
                    !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
                }, ae = (e, t, n)=>{
                    if (n.inputLabel) {
                        const o = document.createElement("label"), i = s["input-label"];
                        o.setAttribute("for", e.id), o.className = i, typeof n.customClass == "object" && b(o, n.customClass.inputLabel), o.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", o);
                    }
                }, At = (e)=>{
                    const t = m();
                    if (t) return R(t, s[e] || s.input);
                }, Ce = (e, t)=>{
                    [
                        "string",
                        "number"
                    ].includes(typeof t) ? e.value = `${t}` : Fe(t) || P(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
                }, C = {};
                C.text = C.email = C.password = C.number = C.tel = C.url = C.search = C.date = C["datetime-local"] = C.time = C.week = C.month = (e, t)=>(Ce(e, t.inputValue), ae(e, e, t), Ge(e, t), e.type = t.input, e), C.file = (e, t)=>(ae(e, e, t), Ge(e, t), e), C.range = (e, t)=>{
                    const n = e.querySelector("input"), o = e.querySelector("output");
                    return Ce(n, t.inputValue), n.type = t.input, Ce(o, t.inputValue), ae(n, e, t), e;
                }, C.select = (e, t)=>{
                    if (e.textContent = "", t.inputPlaceholder) {
                        const n = document.createElement("option");
                        O(n, t.inputPlaceholder), n.value = "", n.disabled = !0, n.selected = !0, e.appendChild(n);
                    }
                    return ae(e, e, t), e;
                }, C.radio = (e)=>(e.textContent = "", e), C.checkbox = (e, t)=>{
                    const n = ve(m(), "checkbox");
                    n.value = "1", n.checked = !!t.inputValue;
                    const o = e.querySelector("span");
                    return O(o, t.inputPlaceholder || t.inputLabel), n;
                }, C.textarea = (e, t)=>{
                    Ce(e, t.inputValue), Ge(e, t), ae(e, e, t);
                    const n = (o)=>parseInt(window.getComputedStyle(o).marginLeft) + parseInt(window.getComputedStyle(o).marginRight);
                    return setTimeout(()=>{
                        if ("MutationObserver" in window) {
                            const o = parseInt(window.getComputedStyle(m()).width), i = ()=>{
                                if (!document.body.contains(e)) return;
                                const a = e.offsetWidth + n(e);
                                a > o ? m().style.width = `${a}px` : z(m(), "width", t.width);
                            };
                            new MutationObserver(i).observe(e, {
                                attributes: !0,
                                attributeFilter: [
                                    "style"
                                ]
                            });
                        }
                    }), e;
                };
                const Po = (e, t)=>{
                    const n = Ve();
                    n && (Ue(n), M(n, t, "htmlContainer"), t.html ? (Ke(t.html, n), E(n, "block")) : t.text ? (n.textContent = t.text, E(n, "block")) : A(n), vo(e, t));
                }, Bo = (e, t)=>{
                    const n = wt();
                    n && (Ue(n), ue(n, !!t.footer, "block"), t.footer && Ke(t.footer, n), M(n, t, "footer"));
                }, So = (e, t)=>{
                    const n = w.innerParams.get(e), o = Z();
                    if (!o) return;
                    if (n && t.icon === n.icon) {
                        St(o, t), Pt(o, t);
                        return;
                    }
                    if (!t.icon && !t.iconHtml) {
                        A(o);
                        return;
                    }
                    if (t.icon && Object.keys(F).indexOf(t.icon) === -1) {
                        U(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), A(o);
                        return;
                    }
                    E(o), St(o, t), Pt(o, t), b(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", Bt);
                }, Pt = (e, t)=>{
                    for (const [n, o] of Object.entries(F))t.icon !== n && j(e, o);
                    b(e, t.icon && F[t.icon]), Lo(e, t), Bt(), M(e, t, "icon");
                }, Bt = ()=>{
                    const e = m();
                    if (!e) return;
                    const t = window.getComputedStyle(e).getPropertyValue("background-color"), n = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
                    for(let o = 0; o < n.length; o++)n[o].style.backgroundColor = t;
                }, $o = (e)=>`
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, To = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, St = (e, t)=>{
                    if (!t.icon && !t.iconHtml) return;
                    let n = e.innerHTML, o = "";
                    t.iconHtml ? o = $t(t.iconHtml) : t.icon === "success" ? (o = $o(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? o = To : t.icon && (o = $t({
                        question: "?",
                        warning: "!",
                        info: "i"
                    }[t.icon])), n.trim() !== o.trim() && O(e, o);
                }, Lo = (e, t)=>{
                    if (t.iconColor) {
                        e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
                        for (const n of [
                            ".swal2-success-line-tip",
                            ".swal2-success-line-long",
                            ".swal2-x-mark-line-left",
                            ".swal2-x-mark-line-right"
                        ])kt(e, n, "background-color", t.iconColor);
                        kt(e, ".swal2-success-ring", "border-color", t.iconColor);
                    }
                }, $t = (e)=>`<div class="${s["icon-content"]}">${e}</div>`, xo = (e, t)=>{
                    const n = yt();
                    if (n) {
                        if (!t.imageUrl) {
                            A(n);
                            return;
                        }
                        E(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), z(n, "width", t.imageWidth), z(n, "height", t.imageHeight), n.className = s.image, M(n, t, "image");
                    }
                };
                let Ze = !1, Tt = 0, Lt = 0, xt = 0, It = 0;
                const Io = (e)=>{
                    e.addEventListener("mousedown", ke), document.body.addEventListener("mousemove", Ee), e.addEventListener("mouseup", Ae), e.addEventListener("touchstart", ke), document.body.addEventListener("touchmove", Ee), e.addEventListener("touchend", Ae);
                }, Oo = (e)=>{
                    e.removeEventListener("mousedown", ke), document.body.removeEventListener("mousemove", Ee), e.removeEventListener("mouseup", Ae), e.removeEventListener("touchstart", ke), document.body.removeEventListener("touchmove", Ee), e.removeEventListener("touchend", Ae);
                }, ke = (e)=>{
                    const t = m();
                    if (e.target === t || Z().contains(e.target)) {
                        Ze = !0;
                        const n = Ot(e);
                        Tt = n.clientX, Lt = n.clientY, xt = parseInt(t.style.insetInlineStart) || 0, It = parseInt(t.style.insetBlockStart) || 0, b(t, "swal2-dragging");
                    }
                }, Ee = (e)=>{
                    const t = m();
                    if (Ze) {
                        let { clientX: n, clientY: o } = Ot(e);
                        t.style.insetInlineStart = `${xt + (n - Tt)}px`, t.style.insetBlockStart = `${It + (o - Lt)}px`;
                    }
                }, Ae = ()=>{
                    const e = m();
                    Ze = !1, j(e, "swal2-dragging");
                }, Ot = (e)=>{
                    let t = 0, n = 0;
                    return e.type.startsWith("mouse") ? (t = e.clientX, n = e.clientY) : e.type.startsWith("touch") && (t = e.touches[0].clientX, n = e.touches[0].clientY), {
                        clientX: t,
                        clientY: n
                    };
                }, Mo = (e, t)=>{
                    const n = B(), o = m();
                    if (!(!n || !o)) {
                        if (t.toast) {
                            z(n, "width", t.width), o.style.width = "100%";
                            const i = Q();
                            i && o.insertBefore(i, Z());
                        } else z(o, "width", t.width);
                        z(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), A(be()), jo(o, t), t.draggable && !t.toast ? (b(o, s.draggable), Io(o)) : (j(o, s.draggable), Oo(o));
                    }
                }, jo = (e, t)=>{
                    const n = t.showClass || {};
                    e.className = `${s.popup} ${T(e) ? n.popup : ""}`, t.toast ? (b([
                        document.documentElement,
                        document.body
                    ], s["toast-shown"]), b(e, s.toast)) : b(e, s.modal), M(e, t, "popup"), typeof t.customClass == "string" && b(e, t.customClass), t.icon && b(e, s[`icon-${t.icon}`]);
                }, Do = (e, t)=>{
                    const n = qe();
                    if (!n) return;
                    const { progressSteps: o, currentProgressStep: i } = t;
                    if (!o || o.length === 0 || i === void 0) {
                        A(n);
                        return;
                    }
                    E(n), n.textContent = "", i >= o.length && P("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((a, h)=>{
                        const y = Ho(a);
                        if (n.appendChild(y), h === i && b(y, s["active-progress-step"]), h !== o.length - 1) {
                            const v = Fo(t);
                            n.appendChild(v);
                        }
                    });
                }, Ho = (e)=>{
                    const t = document.createElement("li");
                    return b(t, s["progress-step"]), O(t, e), t;
                }, Fo = (e)=>{
                    const t = document.createElement("li");
                    return b(t, s["progress-step-line"]), e.progressStepsDistance && z(t, "width", e.progressStepsDistance), t;
                }, Vo = (e, t)=>{
                    const n = bt();
                    n && (Ue(n), ue(n, !!(t.title || t.titleText), "block"), t.title && Ke(t.title, n), t.titleText && (n.innerText = t.titleText), M(n, t, "title"));
                }, Mt = (e, t)=>{
                    Mo(e, t), ho(e, t), Do(e, t), So(e, t), xo(e, t), Vo(e, t), go(e, t), Po(e, t), ao(e, t), Bo(e, t);
                    const n = m();
                    typeof t.didRender == "function" && n && t.didRender(n), c.eventEmitter.emit("didRender", n);
                }, qo = ()=>T(m()), jt = ()=>{
                    var e;
                    return (e = D()) === null || e === void 0 ? void 0 : e.click();
                }, _o = ()=>{
                    var e;
                    return (e = N()) === null || e === void 0 ? void 0 : e.click();
                }, Ro = ()=>{
                    var e;
                    return (e = J()) === null || e === void 0 ? void 0 : e.click();
                }, ee = Object.freeze({
                    cancel: "cancel",
                    backdrop: "backdrop",
                    close: "close",
                    esc: "esc",
                    timer: "timer"
                }), Dt = (e)=>{
                    e.keydownTarget && e.keydownHandlerAdded && (e.keydownTarget.removeEventListener("keydown", e.keydownHandler, {
                        capture: e.keydownListenerCapture
                    }), e.keydownHandlerAdded = !1);
                }, Wo = (e, t, n)=>{
                    Dt(e), t.toast || (e.keydownHandler = (o)=>No(t, o, n), e.keydownTarget = t.keydownListenerCapture ? window : m(), e.keydownListenerCapture = t.keydownListenerCapture, e.keydownTarget.addEventListener("keydown", e.keydownHandler, {
                        capture: e.keydownListenerCapture
                    }), e.keydownHandlerAdded = !0);
                }, Je = (e, t)=>{
                    var n;
                    const o = Re();
                    if (o.length) {
                        e = e + t, e === -2 && (e = o.length - 1), e === o.length ? e = 0 : e === -1 && (e = o.length - 1), o[e].focus();
                        return;
                    }
                    (n = m()) === null || n === void 0 || n.focus();
                }, Ht = [
                    "ArrowRight",
                    "ArrowDown"
                ], Uo = [
                    "ArrowLeft",
                    "ArrowUp"
                ], No = (e, t, n)=>{
                    e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? zo(t, e) : t.key === "Tab" ? Ko(t) : [
                        ...Ht,
                        ...Uo
                    ].includes(t.key) ? Yo(t.key) : t.key === "Escape" && Xo(t, e, n)));
                }, zo = (e, t)=>{
                    if (!me(t.allowEnterKey)) return;
                    const n = ve(m(), t.input);
                    if (e.target && n && e.target instanceof HTMLElement && e.target.outerHTML === n.outerHTML) {
                        if ([
                            "textarea",
                            "file"
                        ].includes(t.input)) return;
                        jt(), e.preventDefault();
                    }
                }, Ko = (e)=>{
                    const t = e.target, n = Re();
                    let o = -1;
                    for(let i = 0; i < n.length; i++)if (t === n[i]) {
                        o = i;
                        break;
                    }
                    e.shiftKey ? Je(o, -1) : Je(o, 1), e.stopPropagation(), e.preventDefault();
                }, Yo = (e)=>{
                    const t = ce(), n = D(), o = N(), i = J();
                    if (!t || !n || !o || !i) return;
                    const a = [
                        n,
                        o,
                        i
                    ];
                    if (document.activeElement instanceof HTMLElement && !a.includes(document.activeElement)) return;
                    const h = Ht.includes(e) ? "nextElementSibling" : "previousElementSibling";
                    let y = document.activeElement;
                    if (y) {
                        for(let v = 0; v < t.children.length; v++){
                            if (y = y[h], !y) return;
                            if (y instanceof HTMLButtonElement && T(y)) break;
                        }
                        y instanceof HTMLButtonElement && y.focus();
                    }
                }, Xo = (e, t, n)=>{
                    e.preventDefault(), me(t.allowEscapeKey) && n(ee.esc);
                };
                var te = {
                    swalPromiseResolve: new WeakMap,
                    swalPromiseReject: new WeakMap
                };
                const Go = ()=>{
                    const e = B();
                    Array.from(document.body.children).forEach((n)=>{
                        n.contains(e) || (n.hasAttribute("aria-hidden") && n.setAttribute("data-previous-aria-hidden", n.getAttribute("aria-hidden") || ""), n.setAttribute("aria-hidden", "true"));
                    });
                }, Ft = ()=>{
                    Array.from(document.body.children).forEach((t)=>{
                        t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden") || ""), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden");
                    });
                }, Vt = typeof window < "u" && !!window.GestureEvent, Zo = ()=>{
                    if (Vt && !V(document.body, s.iosfix)) {
                        const e = document.body.scrollTop;
                        document.body.style.top = `${e * -1}px`, b(document.body, s.iosfix), Jo();
                    }
                }, Jo = ()=>{
                    const e = B();
                    if (!e) return;
                    let t;
                    e.ontouchstart = (n)=>{
                        t = Qo(n);
                    }, e.ontouchmove = (n)=>{
                        t && (n.preventDefault(), n.stopPropagation());
                    };
                }, Qo = (e)=>{
                    const t = e.target, n = B(), o = Ve();
                    return !n || !o || ei(e) || ti(e) ? !1 : t === n || !Ne(n) && t instanceof HTMLElement && !Jn(t, o) && t.tagName !== "INPUT" && t.tagName !== "TEXTAREA" && !(Ne(o) && o.contains(t));
                }, ei = (e)=>e.touches && e.touches.length && e.touches[0].touchType === "stylus", ti = (e)=>e.touches && e.touches.length > 1, ni = ()=>{
                    if (V(document.body, s.iosfix)) {
                        const e = parseInt(document.body.style.top, 10);
                        j(document.body, s.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
                    }
                }, oi = ()=>{
                    const e = document.createElement("div");
                    e.className = s["scrollbar-measure"], document.body.appendChild(e);
                    const t = e.getBoundingClientRect().width - e.clientWidth;
                    return document.body.removeChild(e), t;
                };
                let ne = null;
                const ii = (e)=>{
                    ne === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (ne = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${ne + oi()}px`);
                }, si = ()=>{
                    ne !== null && (document.body.style.paddingRight = `${ne}px`, ne = null);
                };
                function qt(e, t, n, o) {
                    we() ? Rt(e, o) : (S(n).then(()=>Rt(e, o)), Dt(c)), Vt ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), We() && (si(), ni(), Ft()), ri();
                }
                function ri() {
                    j([
                        document.documentElement,
                        document.body
                    ], [
                        s.shown,
                        s["height-auto"],
                        s["no-backdrop"],
                        s["toast-shown"]
                    ]);
                }
                function W(e) {
                    e = ci(e);
                    const t = te.swalPromiseResolve.get(this), n = li(this);
                    this.isAwaitingPromise ? e.isDismissed || (de(this), t(e)) : n && t(e);
                }
                const li = (e)=>{
                    const t = m();
                    if (!t) return !1;
                    const n = w.innerParams.get(e);
                    if (!n || V(t, n.hideClass.popup)) return !1;
                    j(t, n.showClass.popup), b(t, n.hideClass.popup);
                    const o = B();
                    return j(o, n.showClass.backdrop), b(o, n.hideClass.backdrop), ui(e, t, n), !0;
                };
                function _t(e) {
                    const t = te.swalPromiseReject.get(this);
                    de(this), t && t(e);
                }
                const de = (e)=>{
                    e.isAwaitingPromise && (delete e.isAwaitingPromise, w.innerParams.get(e) || e._destroy());
                }, ci = (e)=>typeof e > "u" ? {
                        isConfirmed: !1,
                        isDenied: !1,
                        isDismissed: !0
                    } : Object.assign({
                        isConfirmed: !1,
                        isDenied: !1,
                        isDismissed: !1
                    }, e), ui = (e, t, n)=>{
                    var o;
                    const i = B(), a = Et(t);
                    typeof n.willClose == "function" && n.willClose(t), (o = c.eventEmitter) === null || o === void 0 || o.emit("willClose", t), a ? ai(e, t, i, n.returnFocus, n.didClose) : qt(e, i, n.returnFocus, n.didClose);
                }, ai = (e, t, n, o, i)=>{
                    c.swalCloseEventFinishedCallback = qt.bind(null, e, n, o, i);
                    const a = function(h) {
                        if (h.target === t) {
                            var y;
                            (y = c.swalCloseEventFinishedCallback) === null || y === void 0 || y.call(c), delete c.swalCloseEventFinishedCallback, t.removeEventListener("animationend", a), t.removeEventListener("transitionend", a);
                        }
                    };
                    t.addEventListener("animationend", a), t.addEventListener("transitionend", a);
                }, Rt = (e, t)=>{
                    setTimeout(()=>{
                        var n;
                        typeof t == "function" && t.bind(e.params)(), (n = c.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
                    });
                }, oe = (e)=>{
                    let t = m();
                    if (t || new Le, t = m(), !t) return;
                    const n = Q();
                    we() ? A(Z()) : di(t, e), E(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
                }, di = (e, t)=>{
                    const n = ce(), o = Q();
                    !n || !o || (!t && T(D()) && (t = D()), E(n), t && (A(t), o.setAttribute("data-button-to-replace", t.className), n.insertBefore(o, t)), b([
                        e,
                        n
                    ], s.loading));
                }, fi = (e, t)=>{
                    t.input === "select" || t.input === "radio" ? bi(e, t) : [
                        "text",
                        "email",
                        "number",
                        "tel",
                        "textarea"
                    ].some((n)=>n === t.input) && (He(t.inputValue) || Fe(t.inputValue)) && (oe(D()), yi(e, t));
                }, pi = (e, t)=>{
                    const n = e.getInput();
                    if (!n) return null;
                    switch(t.input){
                        case "checkbox":
                            return gi(n);
                        case "radio":
                            return hi(n);
                        case "file":
                            return mi(n);
                        default:
                            return t.inputAutoTrim ? n.value.trim() : n.value;
                    }
                }, gi = (e)=>e.checked ? 1 : 0, hi = (e)=>e.checked ? e.value : null, mi = (e)=>e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, bi = (e, t)=>{
                    const n = m();
                    if (!n) return;
                    const o = (i)=>{
                        t.input === "select" ? wi(n, Pe(i), t) : t.input === "radio" && vi(n, Pe(i), t);
                    };
                    He(t.inputOptions) || Fe(t.inputOptions) ? (oe(D()), re(t.inputOptions).then((i)=>{
                        e.hideLoading(), o(i);
                    })) : typeof t.inputOptions == "object" ? o(t.inputOptions) : U(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
                }, yi = (e, t)=>{
                    const n = e.getInput();
                    n && (A(n), re(t.inputValue).then((o)=>{
                        n.value = t.input === "number" ? `${parseFloat(o) || 0}` : `${o}`, E(n), n.focus(), e.hideLoading();
                    }).catch((o)=>{
                        U(`Error in inputValue promise: ${o}`), n.value = "", E(n), n.focus(), e.hideLoading();
                    }));
                };
                function wi(e, t, n) {
                    const o = R(e, s.select);
                    if (!o) return;
                    const i = (a, h, y)=>{
                        const v = document.createElement("option");
                        v.value = y, O(v, h), v.selected = Wt(y, n.inputValue), a.appendChild(v);
                    };
                    t.forEach((a)=>{
                        const h = a[0], y = a[1];
                        if (Array.isArray(y)) {
                            const v = document.createElement("optgroup");
                            v.label = h, v.disabled = !1, o.appendChild(v), y.forEach((se)=>i(v, se[1], se[0]));
                        } else i(o, y, h);
                    }), o.focus();
                }
                function vi(e, t, n) {
                    const o = R(e, s.radio);
                    if (!o) return;
                    t.forEach((a)=>{
                        const h = a[0], y = a[1], v = document.createElement("input"), se = document.createElement("label");
                        v.type = "radio", v.name = s.radio, v.value = h, Wt(h, n.inputValue) && (v.checked = !0);
                        const ot = document.createElement("span");
                        O(ot, y), ot.className = s.label, se.appendChild(v), se.appendChild(ot), o.appendChild(se);
                    });
                    const i = o.querySelectorAll("input");
                    i.length && i[0].focus();
                }
                const Pe = (e)=>{
                    const t = [];
                    return e instanceof Map ? e.forEach((n, o)=>{
                        let i = n;
                        typeof i == "object" && (i = Pe(i)), t.push([
                            o,
                            i
                        ]);
                    }) : Object.keys(e).forEach((n)=>{
                        let o = e[n];
                        typeof o == "object" && (o = Pe(o)), t.push([
                            n,
                            o
                        ]);
                    }), t;
                }, Wt = (e, t)=>!!t && t.toString() === e.toString(), Ci = (e)=>{
                    const t = w.innerParams.get(e);
                    e.disableButtons(), t.input ? Ut(e, "confirm") : et(e, !0);
                }, ki = (e)=>{
                    const t = w.innerParams.get(e);
                    e.disableButtons(), t.returnInputValueOnDeny ? Ut(e, "deny") : Qe(e, !1);
                }, Ei = (e, t)=>{
                    e.disableButtons(), t(ee.cancel);
                }, Ut = (e, t)=>{
                    const n = w.innerParams.get(e);
                    if (!n.input) {
                        U(`The "input" parameter is needed to be set when using returnInputValueOn${_(t)}`);
                        return;
                    }
                    const o = e.getInput(), i = pi(e, n);
                    n.inputValidator ? Ai(e, i, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || o.validationMessage)) : t === "deny" ? Qe(e, i) : et(e, i);
                }, Ai = (e, t, n)=>{
                    const o = w.innerParams.get(e);
                    e.disableInput(), Promise.resolve().then(()=>re(o.inputValidator(t, o.validationMessage))).then((a)=>{
                        e.enableButtons(), e.enableInput(), a ? e.showValidationMessage(a) : n === "deny" ? Qe(e, t) : et(e, t);
                    });
                }, Qe = (e, t)=>{
                    const n = w.innerParams.get(e || void 0);
                    n.showLoaderOnDeny && oe(N()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(()=>re(n.preDeny(t, n.validationMessage))).then((i)=>{
                        i === !1 ? (e.hideLoading(), de(e)) : e.close({
                            isDenied: !0,
                            value: typeof i > "u" ? t : i
                        });
                    }).catch((i)=>zt(e || void 0, i))) : e.close({
                        isDenied: !0,
                        value: t
                    });
                }, Nt = (e, t)=>{
                    e.close({
                        isConfirmed: !0,
                        value: t
                    });
                }, zt = (e, t)=>{
                    e.rejectPromise(t);
                }, et = (e, t)=>{
                    const n = w.innerParams.get(e || void 0);
                    n.showLoaderOnConfirm && oe(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(()=>re(n.preConfirm(t, n.validationMessage))).then((i)=>{
                        T(be()) || i === !1 ? (e.hideLoading(), de(e)) : Nt(e, typeof i > "u" ? t : i);
                    }).catch((i)=>zt(e || void 0, i))) : Nt(e, t);
                };
                function Be() {
                    const e = w.innerParams.get(this);
                    if (!e) return;
                    const t = w.domCache.get(this);
                    A(t.loader), we() ? e.icon && E(Z()) : Pi(t), j([
                        t.popup,
                        t.actions
                    ], s.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), t.confirmButton.disabled = !1, t.denyButton.disabled = !1, t.cancelButton.disabled = !1;
                }
                const Pi = (e)=>{
                    const t = e.popup.getElementsByClassName(e.loader.getAttribute("data-button-to-replace"));
                    t.length ? E(t[0], "inline-block") : Zn() && A(e.actions);
                };
                function Kt() {
                    const e = w.innerParams.get(this), t = w.domCache.get(this);
                    return t ? ve(t.popup, e.input) : null;
                }
                function Yt(e, t, n) {
                    const o = w.domCache.get(e);
                    t.forEach((i)=>{
                        o[i].disabled = n;
                    });
                }
                function Xt(e, t) {
                    const n = m();
                    if (!(!n || !e)) {
                        if (e.type === "radio") {
                            const o = n.querySelectorAll(`[name="${s.radio}"]`);
                            for(let i = 0; i < o.length; i++)o[i].disabled = t;
                        } else e.disabled = t;
                    }
                }
                function Gt() {
                    Yt(this, [
                        "confirmButton",
                        "denyButton",
                        "cancelButton"
                    ], !1);
                }
                function Zt() {
                    Yt(this, [
                        "confirmButton",
                        "denyButton",
                        "cancelButton"
                    ], !0);
                }
                function Jt() {
                    Xt(this.getInput(), !1);
                }
                function Qt() {
                    Xt(this.getInput(), !0);
                }
                function en(e) {
                    const t = w.domCache.get(this), n = w.innerParams.get(this);
                    O(t.validationMessage, e), t.validationMessage.className = s["validation-message"], n.customClass && n.customClass.validationMessage && b(t.validationMessage, n.customClass.validationMessage), E(t.validationMessage);
                    const o = this.getInput();
                    o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", s["validation-message"]), vt(o), b(o, s.inputerror));
                }
                function tn() {
                    const e = w.domCache.get(this);
                    e.validationMessage && A(e.validationMessage);
                    const t = this.getInput();
                    t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), j(t, s.inputerror));
                }
                const ie = {
                    title: "",
                    titleText: "",
                    text: "",
                    html: "",
                    footer: "",
                    icon: void 0,
                    iconColor: void 0,
                    iconHtml: void 0,
                    template: void 0,
                    toast: !1,
                    draggable: !1,
                    animation: !0,
                    theme: "light",
                    showClass: {
                        popup: "swal2-show",
                        backdrop: "swal2-backdrop-show",
                        icon: "swal2-icon-show"
                    },
                    hideClass: {
                        popup: "swal2-hide",
                        backdrop: "swal2-backdrop-hide",
                        icon: "swal2-icon-hide"
                    },
                    customClass: {},
                    target: "body",
                    color: void 0,
                    backdrop: !0,
                    heightAuto: !0,
                    allowOutsideClick: !0,
                    allowEscapeKey: !0,
                    allowEnterKey: !0,
                    stopKeydownPropagation: !0,
                    keydownListenerCapture: !1,
                    showConfirmButton: !0,
                    showDenyButton: !1,
                    showCancelButton: !1,
                    preConfirm: void 0,
                    preDeny: void 0,
                    confirmButtonText: "OK",
                    confirmButtonAriaLabel: "",
                    confirmButtonColor: void 0,
                    denyButtonText: "No",
                    denyButtonAriaLabel: "",
                    denyButtonColor: void 0,
                    cancelButtonText: "Cancel",
                    cancelButtonAriaLabel: "",
                    cancelButtonColor: void 0,
                    buttonsStyling: !0,
                    reverseButtons: !1,
                    focusConfirm: !0,
                    focusDeny: !1,
                    focusCancel: !1,
                    returnFocus: !0,
                    showCloseButton: !1,
                    closeButtonHtml: "&times;",
                    closeButtonAriaLabel: "Close this dialog",
                    loaderHtml: "",
                    showLoaderOnConfirm: !1,
                    showLoaderOnDeny: !1,
                    imageUrl: void 0,
                    imageWidth: void 0,
                    imageHeight: void 0,
                    imageAlt: "",
                    timer: void 0,
                    timerProgressBar: !1,
                    width: void 0,
                    padding: void 0,
                    background: void 0,
                    input: void 0,
                    inputPlaceholder: "",
                    inputLabel: "",
                    inputValue: "",
                    inputOptions: {},
                    inputAutoFocus: !0,
                    inputAutoTrim: !0,
                    inputAttributes: {},
                    inputValidator: void 0,
                    returnInputValueOnDeny: !1,
                    validationMessage: void 0,
                    grow: !1,
                    position: "center",
                    progressSteps: [],
                    currentProgressStep: void 0,
                    progressStepsDistance: void 0,
                    willOpen: void 0,
                    didOpen: void 0,
                    didRender: void 0,
                    willClose: void 0,
                    didClose: void 0,
                    didDestroy: void 0,
                    scrollbarPadding: !0,
                    topLayer: !1
                }, Bi = [
                    "allowEscapeKey",
                    "allowOutsideClick",
                    "background",
                    "buttonsStyling",
                    "cancelButtonAriaLabel",
                    "cancelButtonColor",
                    "cancelButtonText",
                    "closeButtonAriaLabel",
                    "closeButtonHtml",
                    "color",
                    "confirmButtonAriaLabel",
                    "confirmButtonColor",
                    "confirmButtonText",
                    "currentProgressStep",
                    "customClass",
                    "denyButtonAriaLabel",
                    "denyButtonColor",
                    "denyButtonText",
                    "didClose",
                    "didDestroy",
                    "draggable",
                    "footer",
                    "hideClass",
                    "html",
                    "icon",
                    "iconColor",
                    "iconHtml",
                    "imageAlt",
                    "imageHeight",
                    "imageUrl",
                    "imageWidth",
                    "preConfirm",
                    "preDeny",
                    "progressSteps",
                    "returnFocus",
                    "reverseButtons",
                    "showCancelButton",
                    "showCloseButton",
                    "showConfirmButton",
                    "showDenyButton",
                    "text",
                    "title",
                    "titleText",
                    "theme",
                    "willClose"
                ], Si = {
                    allowEnterKey: void 0
                }, $i = [
                    "allowOutsideClick",
                    "allowEnterKey",
                    "backdrop",
                    "draggable",
                    "focusConfirm",
                    "focusDeny",
                    "focusCancel",
                    "returnFocus",
                    "heightAuto",
                    "keydownListenerCapture"
                ], nn = (e)=>Object.prototype.hasOwnProperty.call(ie, e), on = (e)=>Bi.indexOf(e) !== -1, sn = (e)=>Si[e], Ti = (e)=>{
                    nn(e) || P(`Unknown parameter "${e}"`);
                }, Li = (e)=>{
                    $i.includes(e) && P(`The parameter "${e}" is incompatible with toasts`);
                }, xi = (e)=>{
                    const t = sn(e);
                    t && mt(e, t);
                }, rn = (e)=>{
                    e.backdrop === !1 && e.allowOutsideClick && P('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && ![
                        "light",
                        "dark",
                        "auto",
                        "minimal",
                        "borderless",
                        "bootstrap-4",
                        "bootstrap-4-light",
                        "bootstrap-4-dark",
                        "bootstrap-5",
                        "bootstrap-5-light",
                        "bootstrap-5-dark",
                        "material-ui",
                        "material-ui-light",
                        "material-ui-dark",
                        "embed-iframe",
                        "bulma",
                        "bulma-light",
                        "bulma-dark"
                    ].includes(e.theme) && P(`Invalid theme "${e.theme}"`);
                    for(const t in e)Ti(t), e.toast && Li(t), xi(t);
                };
                function ln(e) {
                    const t = B(), n = m(), o = w.innerParams.get(this);
                    if (!n || V(n, o.hideClass.popup)) {
                        P("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
                        return;
                    }
                    const i = Ii(e), a = Object.assign({}, o, i);
                    rn(a), t.dataset.swal2Theme = a.theme, Mt(this, a), w.innerParams.set(this, a), Object.defineProperties(this, {
                        params: {
                            value: Object.assign({}, this.params, e),
                            writable: !1,
                            enumerable: !0
                        }
                    });
                }
                const Ii = (e)=>{
                    const t = {};
                    return Object.keys(e).forEach((n)=>{
                        on(n) ? t[n] = e[n] : P(`Invalid parameter to update: ${n}`);
                    }), t;
                };
                function cn() {
                    const e = w.domCache.get(this), t = w.innerParams.get(this);
                    if (!t) {
                        un(this);
                        return;
                    }
                    e.popup && c.swalCloseEventFinishedCallback && (c.swalCloseEventFinishedCallback(), delete c.swalCloseEventFinishedCallback), typeof t.didDestroy == "function" && t.didDestroy(), c.eventEmitter.emit("didDestroy"), Oi(this);
                }
                const Oi = (e)=>{
                    un(e), delete e.params, delete c.keydownHandler, delete c.keydownTarget, delete c.currentInstance;
                }, un = (e)=>{
                    e.isAwaitingPromise ? (tt(w, e), e.isAwaitingPromise = !0) : (tt(te, e), tt(w, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
                }, tt = (e, t)=>{
                    for(const n in e)e[n].delete(t);
                };
                var Mi = Object.freeze({
                    __proto__: null,
                    _destroy: cn,
                    close: W,
                    closeModal: W,
                    closePopup: W,
                    closeToast: W,
                    disableButtons: Zt,
                    disableInput: Qt,
                    disableLoading: Be,
                    enableButtons: Gt,
                    enableInput: Jt,
                    getInput: Kt,
                    handleAwaitingPromise: de,
                    hideLoading: Be,
                    rejectPromise: _t,
                    resetValidationMessage: tn,
                    showValidationMessage: en,
                    update: ln
                });
                const ji = (e, t, n)=>{
                    e.toast ? Di(e, t, n) : (Fi(t), Vi(t), qi(e, t, n));
                }, Di = (e, t, n)=>{
                    t.popup.onclick = ()=>{
                        e && (Hi(e) || e.timer || e.input) || n(ee.close);
                    };
                }, Hi = (e)=>!!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
                let Se = !1;
                const Fi = (e)=>{
                    e.popup.onmousedown = ()=>{
                        e.container.onmouseup = function(t) {
                            e.container.onmouseup = ()=>{}, t.target === e.container && (Se = !0);
                        };
                    };
                }, Vi = (e)=>{
                    e.container.onmousedown = (t)=>{
                        t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
                            e.popup.onmouseup = ()=>{}, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (Se = !0);
                        };
                    };
                }, qi = (e, t, n)=>{
                    t.container.onclick = (o)=>{
                        if (Se) {
                            Se = !1;
                            return;
                        }
                        o.target === t.container && me(e.allowOutsideClick) && n(ee.backdrop);
                    };
                }, _i = (e)=>typeof e == "object" && e.jquery, an = (e)=>e instanceof Element || _i(e), Ri = (e)=>{
                    const t = {};
                    return typeof e[0] == "object" && !an(e[0]) ? Object.assign(t, e[0]) : [
                        "title",
                        "html",
                        "icon"
                    ].forEach((n, o)=>{
                        const i = e[o];
                        typeof i == "string" || an(i) ? t[n] = i : i !== void 0 && U(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof i}`);
                    }), t;
                };
                function Wi(...e) {
                    return new this(...e);
                }
                function Ui(e) {
                    class t extends this {
                        _main(o, i) {
                            return super._main(o, Object.assign({}, e, i));
                        }
                    }
                    return t;
                }
                const Ni = ()=>c.timeout && c.timeout.getTimerLeft(), dn = ()=>{
                    if (c.timeout) return Qn(), c.timeout.stop();
                }, fn = ()=>{
                    if (c.timeout) {
                        const e = c.timeout.start();
                        return ze(e), e;
                    }
                }, zi = ()=>{
                    const e = c.timeout;
                    return e && (e.running ? dn() : fn());
                }, Ki = (e)=>{
                    if (c.timeout) {
                        const t = c.timeout.increase(e);
                        return ze(t, !0), t;
                    }
                }, Yi = ()=>!!(c.timeout && c.timeout.isRunning());
                let pn = !1;
                const nt = {};
                function Xi(e = "data-swal-template") {
                    nt[e] = this, pn || (document.body.addEventListener("click", Gi), pn = !0);
                }
                const Gi = (e)=>{
                    for(let t = e.target; t && t !== document; t = t.parentNode)for(const n in nt){
                        const o = t.getAttribute(n);
                        if (o) {
                            nt[n].fire({
                                template: o
                            });
                            return;
                        }
                    }
                };
                class Zi {
                    _getHandlersByEventName(t) {
                        return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
                    }
                    on(t, n) {
                        const o = this._getHandlersByEventName(t);
                        o.includes(n) || o.push(n);
                    }
                    once(t, n) {
                        const o = (...i)=>{
                            this.removeListener(t, o), n.apply(this, i);
                        };
                        this.on(t, o);
                    }
                    emit(t, ...n) {
                        this._getHandlersByEventName(t).forEach((o)=>{
                            try {
                                o.apply(this, n);
                            } catch (i) {
                                console.error(i);
                            }
                        });
                    }
                    removeListener(t, n) {
                        const o = this._getHandlersByEventName(t), i = o.indexOf(n);
                        i > -1 && o.splice(i, 1);
                    }
                    removeAllListeners(t) {
                        this.events[t] !== void 0 && (this.events[t].length = 0);
                    }
                    reset() {
                        this.events = {};
                    }
                    constructor(){
                        this.events = {};
                    }
                }
                c.eventEmitter = new Zi;
                var Ji = Object.freeze({
                    __proto__: null,
                    argsToParams: Ri,
                    bindClickHandler: Xi,
                    clickCancel: Ro,
                    clickConfirm: jt,
                    clickDeny: _o,
                    enableLoading: oe,
                    fire: Wi,
                    getActions: ce,
                    getCancelButton: J,
                    getCloseButton: _e,
                    getConfirmButton: D,
                    getContainer: B,
                    getDenyButton: N,
                    getFocusableElements: Re,
                    getFooter: wt,
                    getHtmlContainer: Ve,
                    getIcon: Z,
                    getIconContent: zn,
                    getImage: yt,
                    getInputLabel: Kn,
                    getLoader: Q,
                    getPopup: m,
                    getProgressSteps: qe,
                    getTimerLeft: Ni,
                    getTimerProgressBar: ye,
                    getTitle: bt,
                    getValidationMessage: be,
                    increaseTimer: Ki,
                    isDeprecatedParameter: sn,
                    isLoading: Xn,
                    isTimerRunning: Yi,
                    isUpdatableParameter: on,
                    isValidParameter: nn,
                    isVisible: qo,
                    mixin: Ui,
                    off: (e, t)=>{
                        if (!e) {
                            c.eventEmitter.reset();
                            return;
                        }
                        t ? c.eventEmitter.removeListener(e, t) : c.eventEmitter.removeAllListeners(e);
                    },
                    on: (e, t)=>{
                        c.eventEmitter.on(e, t);
                    },
                    once: (e, t)=>{
                        c.eventEmitter.once(e, t);
                    },
                    resumeTimer: fn,
                    showLoading: oe,
                    stopTimer: dn,
                    toggleTimer: zi
                });
                class Qi {
                    start() {
                        return this.running || (this.running = !0, this.started = new Date, this.id = setTimeout(this.callback, this.remaining)), this.remaining;
                    }
                    stop() {
                        return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= new Date().getTime() - this.started.getTime()), this.remaining;
                    }
                    increase(t) {
                        const n = this.running;
                        return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
                    }
                    getTimerLeft() {
                        return this.running && (this.stop(), this.start()), this.remaining;
                    }
                    isRunning() {
                        return this.running;
                    }
                    constructor(t, n){
                        this.callback = t, this.remaining = n, this.running = !1, this.start();
                    }
                }
                const gn = [
                    "swal-title",
                    "swal-html",
                    "swal-footer"
                ], es = (e)=>{
                    const t = typeof e.template == "string" ? document.querySelector(e.template) : e.template;
                    if (!t) return {};
                    const n = t.content;
                    return cs(n), Object.assign(ts(n), ns(n), os(n), is(n), ss(n), rs(n), ls(n, gn));
                }, ts = (e)=>{
                    const t = {};
                    return Array.from(e.querySelectorAll("swal-param")).forEach((o)=>{
                        Y(o, [
                            "name",
                            "value"
                        ]);
                        const i = o.getAttribute("name"), a = o.getAttribute("value");
                        !i || !a || (typeof ie[i] == "boolean" ? t[i] = a !== "false" : typeof ie[i] == "object" ? t[i] = JSON.parse(a) : t[i] = a);
                    }), t;
                }, ns = (e)=>{
                    const t = {};
                    return Array.from(e.querySelectorAll("swal-function-param")).forEach((o)=>{
                        const i = o.getAttribute("name"), a = o.getAttribute("value");
                        !i || !a || (t[i] = new Function(`return ${a}`)());
                    }), t;
                }, os = (e)=>{
                    const t = {};
                    return Array.from(e.querySelectorAll("swal-button")).forEach((o)=>{
                        Y(o, [
                            "type",
                            "color",
                            "aria-label"
                        ]);
                        const i = o.getAttribute("type");
                        !i || ![
                            "confirm",
                            "cancel",
                            "deny"
                        ].includes(i) || (t[`${i}ButtonText`] = o.innerHTML, t[`show${_(i)}Button`] = !0, o.hasAttribute("color") && (t[`${i}ButtonColor`] = o.getAttribute("color")), o.hasAttribute("aria-label") && (t[`${i}ButtonAriaLabel`] = o.getAttribute("aria-label")));
                    }), t;
                }, is = (e)=>{
                    const t = {}, n = e.querySelector("swal-image");
                    return n && (Y(n, [
                        "src",
                        "width",
                        "height",
                        "alt"
                    ]), n.hasAttribute("src") && (t.imageUrl = n.getAttribute("src") || void 0), n.hasAttribute("width") && (t.imageWidth = n.getAttribute("width") || void 0), n.hasAttribute("height") && (t.imageHeight = n.getAttribute("height") || void 0), n.hasAttribute("alt") && (t.imageAlt = n.getAttribute("alt") || void 0)), t;
                }, ss = (e)=>{
                    const t = {}, n = e.querySelector("swal-icon");
                    return n && (Y(n, [
                        "type",
                        "color"
                    ]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
                }, rs = (e)=>{
                    const t = {}, n = e.querySelector("swal-input");
                    n && (Y(n, [
                        "type",
                        "label",
                        "placeholder",
                        "value"
                    ]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
                    const o = Array.from(e.querySelectorAll("swal-input-option"));
                    return o.length && (t.inputOptions = {}, o.forEach((i)=>{
                        Y(i, [
                            "value"
                        ]);
                        const a = i.getAttribute("value");
                        if (!a) return;
                        const h = i.innerHTML;
                        t.inputOptions[a] = h;
                    })), t;
                }, ls = (e, t)=>{
                    const n = {};
                    for(const o in t){
                        const i = t[o], a = e.querySelector(i);
                        a && (Y(a, []), n[i.replace(/^swal-/, "")] = a.innerHTML.trim());
                    }
                    return n;
                }, cs = (e)=>{
                    const t = gn.concat([
                        "swal-param",
                        "swal-function-param",
                        "swal-button",
                        "swal-image",
                        "swal-icon",
                        "swal-input",
                        "swal-input-option"
                    ]);
                    Array.from(e.children).forEach((n)=>{
                        const o = n.tagName.toLowerCase();
                        t.includes(o) || P(`Unrecognized element <${o}>`);
                    });
                }, Y = (e, t)=>{
                    Array.from(e.attributes).forEach((n)=>{
                        t.indexOf(n.name) === -1 && P([
                            `Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`,
                            `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`
                        ]);
                    });
                }, hn = 10, us = (e)=>{
                    const t = B(), n = m();
                    typeof e.willOpen == "function" && e.willOpen(n), c.eventEmitter.emit("willOpen", n);
                    const i = window.getComputedStyle(document.body).overflowY;
                    fs(t, n, e), setTimeout(()=>{
                        as(t, n);
                    }, hn), We() && (ds(t, e.scrollbarPadding, i), Go()), !we() && !c.previousActiveElement && (c.previousActiveElement = document.activeElement), typeof e.didOpen == "function" && setTimeout(()=>e.didOpen(n)), c.eventEmitter.emit("didOpen", n);
                }, $e = (e)=>{
                    const t = m();
                    if (e.target !== t) return;
                    const n = B();
                    t.removeEventListener("animationend", $e), t.removeEventListener("transitionend", $e), n.style.overflowY = "auto", j(n, s["no-transition"]);
                }, as = (e, t)=>{
                    Et(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", $e), t.addEventListener("transitionend", $e)) : e.style.overflowY = "auto";
                }, ds = (e, t, n)=>{
                    Zo(), t && n !== "hidden" && ii(n), setTimeout(()=>{
                        e.scrollTop = 0;
                    });
                }, fs = (e, t, n)=>{
                    b(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), E(t, "grid"), setTimeout(()=>{
                        b(t, n.showClass.popup), t.style.removeProperty("opacity");
                    }, hn)) : E(t, "grid"), b([
                        document.documentElement,
                        document.body
                    ], s.shown), n.heightAuto && n.backdrop && !n.toast && b([
                        document.documentElement,
                        document.body
                    ], s["height-auto"]);
                };
                var mn = {
                    email: (e, t)=>/^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
                    url: (e, t)=>/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
                };
                function ps(e) {
                    e.inputValidator || (e.input === "email" && (e.inputValidator = mn.email), e.input === "url" && (e.inputValidator = mn.url));
                }
                function gs(e) {
                    (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (P('Target parameter is not valid, defaulting to "body"'), e.target = "body");
                }
                function hs(e) {
                    ps(e), e.showLoaderOnConfirm && !e.preConfirm && P(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), gs(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), lo(e);
                }
                let H;
                var Te = new WeakMap;
                class k {
                    _main(t, n = {}) {
                        if (rn(Object.assign({}, n, t)), c.currentInstance) {
                            const a = te.swalPromiseResolve.get(c.currentInstance), { isAwaitingPromise: h } = c.currentInstance;
                            c.currentInstance._destroy(), h || a({
                                isDismissed: !0
                            }), We() && Ft();
                        }
                        c.currentInstance = H;
                        const o = bs(t, n);
                        hs(o), Object.freeze(o), c.timeout && (c.timeout.stop(), delete c.timeout), clearTimeout(c.restoreFocusTimeout);
                        const i = ys(H);
                        return Mt(H, o), w.innerParams.set(H, o), ms(H, i, o);
                    }
                    then(t) {
                        return f(Te, this).then(t);
                    }
                    finally(t) {
                        return f(Te, this).finally(t);
                    }
                    constructor(...t){
                        if (p(this, Te, void 0), typeof window > "u") return;
                        H = this;
                        const n = Object.freeze(this.constructor.argsToParams(t));
                        this.params = n, this.isAwaitingPromise = !1, g(Te, this, this._main(H.params));
                    }
                }
                const ms = (e, t, n)=>new Promise((o, i)=>{
                        const a = (h)=>{
                            e.close({
                                isDismissed: !0,
                                dismiss: h,
                                isConfirmed: !1,
                                isDenied: !1
                            });
                        };
                        te.swalPromiseResolve.set(e, o), te.swalPromiseReject.set(e, i), t.confirmButton.onclick = ()=>{
                            Ci(e);
                        }, t.denyButton.onclick = ()=>{
                            ki(e);
                        }, t.cancelButton.onclick = ()=>{
                            Ei(e, a);
                        }, t.closeButton.onclick = ()=>{
                            a(ee.close);
                        }, ji(n, t, a), Wo(c, n, a), fi(e, n), us(n), ws(c, n, a), vs(t, n), setTimeout(()=>{
                            t.container.scrollTop = 0;
                        });
                    }), bs = (e, t)=>{
                    const n = es(e), o = Object.assign({}, ie, t, n, e);
                    return o.showClass = Object.assign({}, ie.showClass, o.showClass), o.hideClass = Object.assign({}, ie.hideClass, o.hideClass), o.animation === !1 && (o.showClass = {
                        backdrop: "swal2-noanimation"
                    }, o.hideClass = {}), o;
                }, ys = (e)=>{
                    const t = {
                        popup: m(),
                        container: B(),
                        actions: ce(),
                        confirmButton: D(),
                        denyButton: N(),
                        cancelButton: J(),
                        loader: Q(),
                        closeButton: _e(),
                        validationMessage: be(),
                        progressSteps: qe()
                    };
                    return w.domCache.set(e, t), t;
                }, ws = (e, t, n)=>{
                    const o = ye();
                    A(o), t.timer && (e.timeout = new Qi(()=>{
                        n("timer"), delete e.timeout;
                    }, t.timer), t.timerProgressBar && (E(o), M(o, t, "timerProgressBar"), setTimeout(()=>{
                        e.timeout && e.timeout.running && ze(t.timer);
                    })));
                }, vs = (e, t)=>{
                    if (!t.toast) {
                        if (!me(t.allowEnterKey)) {
                            mt("allowEnterKey"), Es();
                            return;
                        }
                        Cs(e) || ks(e, t) || Je(-1, 1);
                    }
                }, Cs = (e)=>{
                    const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
                    for (const n of t)if (n instanceof HTMLElement && T(n)) return n.focus(), !0;
                    return !1;
                }, ks = (e, t)=>t.focusDeny && T(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && T(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && T(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1, Es = ()=>{
                    document.activeElement instanceof HTMLElement && typeof document.activeElement.blur == "function" && document.activeElement.blur();
                };
                k.prototype.disableButtons = Zt, k.prototype.enableButtons = Gt, k.prototype.getInput = Kt, k.prototype.disableInput = Qt, k.prototype.enableInput = Jt, k.prototype.hideLoading = Be, k.prototype.disableLoading = Be, k.prototype.showValidationMessage = en, k.prototype.resetValidationMessage = tn, k.prototype.close = W, k.prototype.closePopup = W, k.prototype.closeModal = W, k.prototype.closeToast = W, k.prototype.rejectPromise = _t, k.prototype.update = ln, k.prototype._destroy = cn, Object.assign(k, Ji), Object.keys(Mi).forEach((e)=>{
                    k[e] = function(...t) {
                        return H && H[e] ? H[e](...t) : null;
                    };
                }), k.DismissReason = ee, k.version = "11.26.2";
                const Le = k;
                return Le.default = Le, Le;
            }), typeof q < "u" && q.Sweetalert2 && (q.swal = q.sweetAlert = q.Swal = q.SweetAlert = q.Sweetalert2);
        }(ge)), ge.exports;
    }
    var gt = Wn();
    const Un = bn({
        __proto__: null,
        default: Rn(gt)
    }, [
        gt
    ]);
    return fe.register = ft, fe.sendDebugInfo = st, Object.defineProperty(fe, Symbol.toStringTag, {
        value: "Module"
    }), fe;
}({});




})();
//# sourceMappingURL=debug-info.js.map
